import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';
import { WishList } from 'src/app/utils/functions/wishList';
import { SharedService } from 'src/app/shared/services/shared.service';
import { NotifictChangeListService } from '../../services/notifict-change-list.service';

@Component({
  selector: 'app-custom-item-wish-list',
  templateUrl: './custom-item-wish-list.component.html'
})
export class CustomItemWishListComponent implements OnInit{

  @Input() product: IItemWishList = new IItemWishList;
  @Output() listChanges = new EventEmitter<boolean>();
  stock?: number;
  deleteProductCar: boolean = false;
  constructor(
    private wishList: WishList,
    private readonly sharedService : SharedService,
    private notifictChangeListService: NotifictChangeListService
    ){

  }
  ngOnInit(): void {
    this.sharedService.getStockByProduct(
      this.product.idProduct!,
      this.product.product.colorId!,
      this.product.product.measurementSystemDetailId!

    ).subscribe({
      next: (resp) => {
        this.stock = resp.data
      },
      error: (error)=> {
        console.debug(error);
        throw error;
      }
    })
  }
  changeCant(eventData: any){
    this.wishList.updateItemWishList(this.product.product, eventData);
    this.notifictChangeListService.notificationUpdate(this.wishList.countForItems());
    this.listChanges.emit(true);
  }
  delete(){
    this.deleteProductCar = true;
  }
  closeModal(eventData: boolean) {
    this.deleteProductCar = eventData;
  }
  closeModalAndDelete(eventData: boolean) {
    this.deleteProductCar = eventData;
    this.wishList.deleteItem(this.product.product);
    this.notifictChangeListService.notificationUpdate(this.wishList.countForItems());
    this.listChanges.emit(true);
  }

  showTotalPrice() {
    const price = this.product.product.isOnDiscount
      ? this.product.product.priceDiscount
      : this.product.product.price;

    return this.product.cant * price;
  }
}
